import { render, staticRenderFns } from "./recursionTab.vue?vue&type=template&id=6bd4c752&scoped=true&"
import script from "./recursionTab.vue?vue&type=script&lang=js&"
export * from "./recursionTab.vue?vue&type=script&lang=js&"
import style0 from "./recursionTab.vue?vue&type=style&index=0&id=6bd4c752&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd4c752",
  null
  
)

export default component.exports